"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvisoIndisponivel = void 0;
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var meetings_api_1 = require("../../api/meetings-api");
require("./aviso-indisponivel.scss");
var common_helper_1 = require("../../helpers/common-helper");
var AvisoIndisponivel = /** @class */ (function (_super) {
    __extends(AvisoIndisponivel, _super);
    function AvisoIndisponivel(props) {
        var _this = _super.call(this, props) || this;
        Icons_1.initializeIcons();
        var pathname = window.location.pathname;
        _this.state = {
            appConfigs: null,
            appSettings: null,
            ancora: pathname.split("/")[2],
            meetingData: [],
            loader: true,
        };
        return _this;
    }
    /**
    * Used to initialize this component.
    */
    AvisoIndisponivel.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                setTimeout(function () { return _this.setState({ loader: false }); }, 2500);
                this.getAppConfig();
                this.getAppSettings();
                this.getMeetingData();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get App Configs
     * */
    AvisoIndisponivel.prototype.getAppConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppConfig()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                appConfigs: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Get App Settings
     * */
    AvisoIndisponivel.prototype.getAppSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppSettings()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                appSettings: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
    * Get meeting data.
    */
    AvisoIndisponivel.prototype.getMeetingData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getMeetingData(this.state.ancora)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                meetingData: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Render header.
    */
    AvisoIndisponivel.prototype.renderHeader = function () {
        return (this.state.appConfigs ?
            React.createElement(react_northstar_1.Flex, null,
                React.createElement(react_northstar_1.Flex.Item, null,
                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", vAlign: "center" },
                        React.createElement(react_northstar_1.Image, { src: "/images/logo.png" }),
                        React.createElement(react_northstar_1.Text, { weight: "semibold", content: "BALC\u00C3O VIRTUAL", size: "medium" }))),
                React.createElement(react_northstar_1.Flex.Item, { grow: true },
                    React.createElement(react_northstar_1.Flex, { hAlign: "center", vAlign: "center" },
                        React.createElement(react_northstar_1.Label, { className: "headerLabel", content: this.state.appConfigs.tribunal }))),
                React.createElement(react_northstar_1.Flex.Item, null,
                    React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", vAlign: "center", className: "sobre" },
                        React.createElement(react_icons_northstar_1.InfoIcon, { outline: true }),
                        React.createElement(react_northstar_1.Text, { weight: "light", content: "Sobre", size: "small" }))))
            :
                React.createElement(React.Fragment, null));
    };
    /**
    * Render body.
    */
    AvisoIndisponivel.prototype.renderBody = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(react_northstar_1.Flex, { gap: "gap.large", className: "card" },
                React.createElement(react_northstar_1.Avatar, { icon: React.createElement(react_northstar_1.Image, { src: "/images/logo.png" }) }),
                React.createElement(react_northstar_1.Image, { hidden: !this.state.loader, className: "typing", src: "/images/typing.gif" }),
                React.createElement(react_northstar_1.Flex.Item, { grow: true },
                    React.createElement(react_northstar_1.Segment, { hidden: this.state.loader, className: "dialog2", color: "brand", content: React.createElement(react_northstar_1.Flex, { gap: "gap.large", column: true },
                            React.createElement(react_northstar_1.Text, { weight: "bold", size: "large", content: "Bem vindo(a) ao nosso canal de atendimento on-line." }),
                            React.createElement(react_northstar_1.Flex, null,
                                React.createElement(react_northstar_1.Flex, { column: true },
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.large" },
                                        React.createElement(react_northstar_1.Label, { className: "mensagem-label", content: (React.createElement(react_northstar_1.Flex, { column: true },
                                                React.createElement(react_northstar_1.Text, { align: "center", styles: { marginTop: "24px", marginBottom: "24px" }, size: "medium", content: React.createElement("span", null,
                                                        "Atendimento indispon\u00EDvel para ",
                                                        React.createElement("span", { style: { fontWeight: "bold" } }, this.state.meetingData.name),
                                                        " ") }))) })),
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", styles: { marginTop: "15px !important" } },
                                        this.state.appSettings && this.state.appSettings.ajudaComoFunciona &&
                                            React.createElement(react_northstar_1.Button, { content: "Como funciona?", secondary: true, onClick: function () { return window.open(common_helper_1.CommonHelper.checkIfContainHttps(_this.state.appSettings.ajudaComoFunciona), "_blank"); } }),
                                        this.state.appSettings && this.state.appSettings.ajudaPerguntasFrequentes &&
                                            React.createElement(react_northstar_1.Button, { content: "Perguntas frequentes", secondary: true, onClick: function () { return window.open(common_helper_1.CommonHelper.checkIfContainHttps(_this.state.appSettings.ajudaPerguntasFrequentes), "_blank"); } }))),
                                React.createElement(react_northstar_1.Flex.Item, { align: "end", className: "atendimento-indisponivel" },
                                    React.createElement(react_northstar_1.Image, { src: "/images/fora-horario.svg", className: "fora-horario-img" })))) })))));
    };
    /**
     * Render this component.
     * */
    AvisoIndisponivel.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "atendimento-indisponivel" },
                React.createElement("div", { className: "header" },
                    React.createElement(react_northstar_1.Segment, { className: "headerLine", inverted: true, content: this.renderHeader() })),
                React.createElement("div", { className: "body" }, this.renderBody()))));
    };
    return AvisoIndisponivel;
}(React.Component));
exports.AvisoIndisponivel = AvisoIndisponivel;
//# sourceMappingURL=aviso-indisponivel.js.map